import { MouseEventHandler } from 'react';
import MobileMenu from './MobileMenu';

export interface IMobileMenuProps {
  onClose: MouseEventHandler;
  isOpenMenu: boolean;
}

export default MobileMenu;
